import ModalConstants from 'app/shared/constants/ModalConstants';

import PaidInclusionPaymentModal from 'app/shared/containers/paidInclusion/PaymentModal';
import PaidInclusionPostPublishModal from 'app/shared/components/paidInclusion/PostPublishModal';
import PaidInclusionValuePropModal from 'app/shared/components/paidInclusion/ValuePropModal';
import PaidInclusionDeactivationModal from 'app/shared/components/paidInclusion/DeactivationModal';

// declare which components to expose
import AddPropertyModal from './AddPropertyModal';
import EnableApplicationsModal from './EnableApplicationsModal';
import BlockedUserModal from './BlockedUserModal';
import FraudFailureModal from './FraudFailureModal';
import NotificationPromptModal from './NotificationPromptModal';
import PostActivationModal from './PostActivationModal';
import PostDeactivationModal from './PostDeactivationModal';
import VerifyEmailModal from './VerifyEmailModal';
import VerifyEmailFailureModal from './VerifyEmailFailureModal';
import PaymentInfoModal from './PaymentInfoModal';
import ConsolidatedPropertyListModal from './ConsolidatedPropertyListModal';
import UserManagementPropertyListModal from './UserManagementPropertyListModal';
import ConfirmationModal from './ConfirmationModal';
import EditUnitModal from './EditUnitModal';
import SelectTourModal from './SelectTourModal';
import ViewTourModal from './ViewTourModal';
import PropertyPickerModal from './PropertyPickerModal';
import ResendCompanyInviteModal from './ResendCompanyInviteModal';
import BoostAdPreviewsModal from './BoostAdPreviewsModal';
import ActivationErrorModal from './ActivationErrorModal';
import BillingAddPaymentModal from './BillingAddPaymentModal';
import ManageClaimContactsMethodsModal from './ManageClaimContactMethodsModal';

// TODO: refactor following modals to be ModalContainer compatible
// i.e. move named export to the default export map
// export components
export {
    AddPropertyModal, EnableApplicationsModal, VerifyEmailModal, VerifyEmailFailureModal,
};

const Modals = {
    [ModalConstants.FRAUD_FAILURE_MODAL]: FraudFailureModal,
    [ModalConstants.NOTIFICATION_MODAL]: NotificationPromptModal,
    [ModalConstants.POST_ACTIVATION_MODAL]: PostActivationModal,
    [ModalConstants.POST_DEACTIVATION_MODAL]: PostDeactivationModal,
    [ModalConstants.BLOCKED_USER_MODAL]: BlockedUserModal,
    [ModalConstants.PAID_INCLUSION_VALUE_PROP_MODAL]: PaidInclusionValuePropModal,
    [ModalConstants.PAID_INCLUSION_PAYMENT_MODAL]: PaidInclusionPaymentModal,
    [ModalConstants.PAID_INCLUSION_POST_PUBLISH_MODAL]: PaidInclusionPostPublishModal,
    [ModalConstants.PAID_INCLUSION_DEACTIVATION_MODAL]: PaidInclusionDeactivationModal,
    [ModalConstants.PAYMENT_INFO_MODAL]: PaymentInfoModal,
    [ModalConstants.CONSOLIDATED_PROPERTY_LIST_MODAL]: ConsolidatedPropertyListModal,
    [ModalConstants.USER_MANAGEMENT_PROPERTY_LIST_MODAL]: UserManagementPropertyListModal,
    [ModalConstants.CONFIRMATION_MODAL]: ConfirmationModal,
    [ModalConstants.EDIT_UNIT_MODAL]: EditUnitModal,
    [ModalConstants.SELECT_TOUR_MODAL]: SelectTourModal,
    [ModalConstants.VIEW_TOUR_MODAL]: ViewTourModal,
    [ModalConstants.PROPERTY_PICKER_MODAL]: PropertyPickerModal,
    [ModalConstants.RESEND_COMPANY_INVITE_MODAL]: ResendCompanyInviteModal,
    [ModalConstants.BOOST_AD_PREVIEWS]: BoostAdPreviewsModal,
    [ModalConstants.ACTIVATION_ERROR_MODAL]: ActivationErrorModal,
    [ModalConstants.BILLING_ADD_PAYMENT_MODAL]: BillingAddPaymentModal,
    [ModalConstants.MANAGE_CLAIM_CONTACT_METHODS_MODAL]: ManageClaimContactsMethodsModal,
};

export default Modals;
